module.exports = "<iframe *ngIf=\"source\" [src]=\"source\" width=\"100%\" height=\"500px\" id=\"printFrame\"></iframe>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/common-module/common/pdf-viewer/pdf-viewer.component.html
// module id = ./src/app/modules/common-module/common/pdf-viewer/pdf-viewer.component.html
// module chunks = 9